import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { StarFill } from 'react-bootstrap-icons';
import API from '../../config/config';
import httpService from '../../services/httpService';
import appService from '../../services/appService';
import { connect } from 'react-redux';
import { eventAddToCart } from '../../helpers/events';

const ProductDetailWidget = ({
  onToggle,
  setCartItems,
  template,
  data,
  onRatingToggle,
  setRatingData,
  rating,
  ratingStatus,
  showLoader,
  hideLoader
}: any) => {
  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined
    });
    useEffect(() => {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
      };
      window.addEventListener('resize', handleResize);
      handleResize()
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return dimension
  }

  const GoogleAnalyticsAddToCart = (item: any) => {
    const data = {
      currency: 'USD',
      items: [
        {
          id: item.id,
          name: item.displayTitle ? item.displayTitle : item.title,
          discount: item.newPrice !== null ? item.price - item.newPrice : 0,
          affiliation: 'Nexersys Store',
          brand: 'Nexersys',
          // item_category: 'pants',
          // item_variant: 'black',
          price: item.newPrice !== null ? item.newPrice : item.price,
          currency: item.currency ? item.currency.code : 'USD',
          quantity: 1
        }
      ],
      value: item.newPrice !== null ? item.newPrice : item.price
    };
    eventAddToCart(data);
  };

  const addToCart = (id: number) => {
    const cartid = appService.getKey('cartid');
    showLoader();
    GoogleAnalyticsAddToCart(data);
    httpService.invokeApi(
      {
        url: `${API.endpoints.getCart}/${cartid}/cartitems`,
        method: 'put',
        data: {
          productId: id,
          quantity: 1
        }
      },
      (success: boolean, res: any) => {
        if (success && res.id) {
          const request: any = { method: 'get', url: API.endpoints.getCart };
          if (cartid) {
            request.headers = { cartid: cartid };
          }
          httpService.invokeApi(request, (success: boolean, resp: any) => {
            if (success && resp.cartId) {
              appService.setKey('cartid', resp.cartId);
              setCartItems(resp);
              onToggle();
              hideLoader();
            } else {
              hideLoader();
            }
          });
        } else {
          hideLoader();
        }
      }
    );
  };

  const starshow = (value: any) => {
    let starset = [];
    for (let index = 0; index < value; index++) {
      starset.push(<StarFill key={index} className="productdetail-star" />);
    }
    return starset;
  };

  const handleRating = (RatingData: any) => {
    setRatingData(RatingData);
    onRatingToggle();
  };

  return (
    template &&
    data && (
      <div className="prod-overview-conatiner">
        <div className={windowSize.width >= 768 ? 'show' : 'hide'}>
          <div className="container-fluid">
            <div className="container">
              <div className="product-detail-padding">
                <Row xs={1} xl={2} lg={2} md={2}>
                  <Col
                    className="product-detail-col"
                    xs={{ order: 2 }}
                    md={{ order: template.overviewAlignment === 'left' ? 1 : 2 }}
                  >
                    <div className="product-detail-container">
                      <div className="product-detail-flex-left">
                        <div
                          className="title-image"
                          style={{
                            backgroundImage: `url(${data.titleImage ? API.baseUrl + data.titleImage.url : ''})`
                          }}
                        />
                        <h3 className="prod-display-title-desktop" aria-label="display title">{data.displayTitle}</h3>
                        <div>
                          <h3 className="product-detail-price-h3">
                            {data.currencySymbol ? data.currencySymbol : '$'}
                            {data.price}
                          </h3>
                        </div>

                        <div role="main" aria-label="title6">
                          <h6 className="product-detail-financing-h6">Plus Shipping</h6>
                        </div>

                        <div className="productdetail-popstar">
                          {starshow(5)}
                          <span
                            role="region"
                            tabIndex={0}
                            className="product-detail-reviews-popup"
                            onClick={() => {
                              handleRating({ reviews: data.product_reviews, id: data.id, title: data.title });
                            }}
                          >
                            Read Reviews
                          </span>
                        </div>

                        <div
                          onClick={() => {
                            addToCart(data.id);
                          }}
                        >
                          <button className="button-show-now">{template.buttonLabel}</button>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col
                    className="product-detail-col"
                    xs={{ order: 2 }}
                    md={{ order: template.imageAlignment === 'right' ? 2 : 1 }}
                  >
                    <div className="product-detail-container">
                      <div className="product-detail-flex">
                        <img
                          className="product-detail-img"
                          src={data.image ? API.baseUrl + data.image.url : ''}
                          alt={data.image ? data.image.alternativeText : ''}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        <div className={windowSize.width < 768 ? 'show' : 'hide'}>
          <div className="container-fluid" role="main">
            <div className="container">
              <div className="product-detail-padding">
                <Row xs={1} xl={2} sm={1} lg={1} md={1}>
                  <Col xs={{ order: 1 }} md={{ order: 1 }}>
                    <div className="product-detail-container">
                      <div className="product-detail-flex-left">
                        <div
                          className="title-image"
                          style={{
                            backgroundImage: `url(${data.titleImage ? API.baseUrl + data.titleImage.url : ''})`
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col className="product-detail-col" xs={{ order: 3 }} md={{ order: 3 }}>
                    <div className="product-detail-container">
                      <div className="product-detail-flex-left">
                        <h3 className="prod-display-title-mobile">{data.title}</h3>
                        <div>
                          <h3 className="product-detail-price-h3">
                            {data.currencySymbol ? data.currencySymbol : '$'}
                            {data.price}
                          </h3>
                        </div>

                        <div aria-label="title6">
                          <h6 className="product-detail-financing-h6">Plus Shipping</h6>
                        </div>

                        <div className="productdetail-popstar">
                          {starshow(5)}

                          <span
                            tabIndex={0}
                            className="product-detail-reviews-popup"
                            onClick={() => {
                              handleRating({ reviews: data.product_reviews, id: data.id, title: data.title });
                            }}
                          >
                            Read Reviews
                          </span>
                        </div>

                        <div>
                          <span className="button-show-now">{template.buttonLabel}</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col className="product-detail-col" xs={{ order: 2 }} md={{ order: 2 }}>
                    <div className="product-detail-container">
                      <div className="product-detail-flex">
                        <img
                          className="product-detail-img"
                          src={data.image ? API.baseUrl + data.image.url : ''}
                          alt={data.image ? data.image.alternativeText : ''}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

const mapState = (state: any) => {
  return {
    status: state.cartStatus,
    cart: state.cart,
    rating: state.rating,
    ratingStatus: state.ratingStatus
  };
};

const mapDispatch = (dispatch: any) => {
  return {
    onToggle: () => dispatch({ type: 'TOGGLE_CART' }),
    setCartItems: (cartItems: any) => {
      dispatch({ type: 'ON_CART_LOAD', payload: cartItems });
    },
    onRatingToggle: () => dispatch({ type: 'RATING_TOGGLE' }),
    setRatingData: (RatingData: any) => {
      dispatch({ type: 'ON_RATING_LOAD', payload: RatingData });
    },
    showLoader: () => dispatch({ type: 'LOADER_SHOW' }),
    hideLoader: () => dispatch({ type: 'LOADER_HIDE' })
  };
};

export default connect(
  mapState,
  mapDispatch
)(ProductDetailWidget);
